import { Injectable } from "@angular/core";
import { Constants } from "@app/constants/constants";
import { NgxPermissionsObject, NgxPermissionsService } from "ngx-permissions";

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {
    private permissionsObject: NgxPermissionsObject;
    private permissionItems: Array<string>;

    constructor(private permissionsService: NgxPermissionsService) {
    }

    public loadPermissions(permissions: string[]) {
        this.permissionsService.loadPermissions(permissions);
        this.permissionsObject = this.permissionsService.getPermissions();
    }

    public flushPermissions() {
        this.permissionsService.flushPermissions();
    }

    private permissions = {
        [Constants.ACL.Admin]: [Constants.UserRole.ADMIN],
        [Constants.ACL.NormalUser]: [Constants.UserRole.ADMIN, Constants.UserRole.USER]
    };

    public hasPermission(permissionSlug: string) {
        if (this.permissionItems && permissionSlug) {
            if (this.permissionItems.indexOf(permissionSlug.toLowerCase()) > -1) {
                return true;
            }
        }
        return false;
    }

    public isAdmin() {
        let loginInfo = this.getCurrentUserInfo();
        if (loginInfo?.roles) {
            return loginInfo.roles.some(role => role === "ADMIN" || role === "ADMINISTRATOR");
        }
        return false;
    }

    private getCurrentUserInfo(): any {
        const userInfo = localStorage.getItem(Constants.LocalStorageKey.USER);
        if (userInfo) {
            let currentUser = JSON.parse(userInfo);
            if (currentUser.permissions) {
                this.permissionItems = [...currentUser.permissions].map(element => element.toLowerCase());
            }
            return currentUser;
        }
        return null;
    }

}
